'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = require('react-google-maps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mapa = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Mapa, _Component);

  function Mapa() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Mapa);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Mapa.__proto__ || (0, _getPrototypeOf2.default)(Mapa)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      center: {
        lat: 48.38936822862816,
        lng: 37.66634256083989
      },
      isWrong: false,
      pinIcons: {
        pinOn: _this.context.baseUrl + '/media/image/pinOn.png',
        pinOff: _this.context.baseUrl + '/media/image/pinOff.png'
      },
      markers: [{
        id: 'Makiivka',
        iconUrl: _this.context.baseUrl + '/media/image/pinOff.png',
        position: { lat: 48.0454468, lng: 37.823037 },
        showInfo: false,
        infoContent: 'Makiivka',
        animationPin: '0',
        visible: false
      }, {
        id: 'Zuhres',
        iconUrl: _this.context.baseUrl + '/media/image/pinOff.png',
        position: { lat: 48.0179342, lng: 38.2297352 },
        showInfo: false,
        infoContent: 'Zuhres',
        animationPin: '0',
        visible: false
      }, {
        id: 'Torez',
        iconUrl: _this.context.baseUrl + '/media/image/pinOff.png',
        position: { lat: 48.0334537, lng: 38.5514329 },
        showInfo: false,
        infoContent: 'Torez',
        animationPin: '0',
        visible: false
      }, {
        id: 'Snizhne',
        iconUrl: _this.context.baseUrl + '/media/image/pinOff.png',
        position: { lat: 48.03942, lng: 38.7154102 },
        showInfo: false,
        infoContent: 'Snizhne',
        animationPin: '0',
        visible: false
      }, {
        id: 'Luhansk',
        iconUrl: _this.context.baseUrl + '/media/image/pinOff.png',
        position: { lat: 48.5799791, lng: 38.2168846 },
        showInfo: false,
        infoContent: 'Luhansk',
        animationPin: '0',
        visible: false
      }, {
        id: 'Pervomaysk',
        iconUrl: _this.context.baseUrl + '/media/image/pinEnd.png',
        position: { lat: 48.6282443, lng: 38.5352013 },
        showInfo: true,
        infoContent: 'Lugar de lanzamiento del misil',
        animationPin: '0',
        visible: true
      }, {
        id: 'Grabovo',
        iconUrl: _this.context.baseUrl + '/media/image/pinEnd.png',
        position: { lat: 48.2035735, lng: 38.1090031 },
        showInfo: true,
        infoContent: 'Lugar en el que cayó el avión',
        animationPin: '0',
        visible: true
      }],
      markersa: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Mapa, [{
    key: 'checkPin',
    value: function checkPin(ev) {
      var _this2 = this;

      var elem = ev.target.dataset.marker ? ev.target : ev.target.parentElement;
      var twMarker = elem.dataset.marker;
      var markers = this.refs;
      var findPin = false;

      var indexMarker = void 0;
      (0, _keys2.default)(markers).map(function (key) {
        if (markers[key].props.record_id == twMarker) {
          indexMarker = key.substr(key.length - 1);
          findPin = true;
        }
      });

      if (findPin) {
        elem.classList.add('selected');
        this.showPin(indexMarker);
      } else {
        elem.classList.add('failCombination');
        setTimeout(function () {
          document.getElementsByClassName('failCombination')[0].classList.remove('failCombination');
        }.bind(this), 1000);

        /*Mostramos texto de error*/
        this.setState({
          isWrong: true
        }, function () {

          setTimeout(function () {
            this.setState({ isWrong: false });
          }.bind(_this2), 3000);
        });
      }
    }
  }, {
    key: 'showPin',
    value: function showPin(indexMarker) {
      var newIcon = this.state.pinIcons.pinOn;
      var stateCopy = (0, _assign2.default)({}, this.state);
      // stateCopy.markers[indexMarker].showInfo = true;
      stateCopy.markers[indexMarker].iconUrl = newIcon;
      stateCopy.markers[indexMarker].animationPin = '1';
      stateCopy.markers[indexMarker].visible = true;

      if (stateCopy.markers[indexMarker].id == 'Pervomaysk') {
        stateCopy.markers[indexMarker].showInfo = true;
      }
      this.setState(stateCopy);

      setTimeout(function () {
        stateCopy.markers[indexMarker].animationPin = '0';
        this.setState(stateCopy);
      }.bind(this), 2100);

      this.checkIfAllAreVisibles();
    }
  }, {
    key: 'checkIfAllAreVisibles',
    value: function checkIfAllAreVisibles() {
      var markers = this.state.markers;
      var numVisibles = 0;

      (0, _keys2.default)(markers).map(function (key) {
        if (markers[key].visible) {
          numVisibles++;
        }
      });

      if (numVisibles == markers.length) {
        this.showDirections();
      }
    }
  }, {
    key: 'showDirections',
    value: function showDirections() {
      var markers = this.state.markers;
      var mapa = this.gmap.props.map;
      var self = this;

      (0, _keys2.default)(markers).map(function (key) {

        var polylineOptionsActual = new google.maps.Polyline({
          strokeColor: '#FFFFFF',
          strokeOpacity: 1.0
        });

        var directionsService = new google.maps.DirectionsService(),
            directionsDisplay = new google.maps.DirectionsRenderer({
          preserveViewport: true, //para que no resetee ni el zoom ni el center
          map: mapa,
          suppressMarkers: true,
          polylineOptions: polylineOptionsActual
        });

        var next = parseInt(key) + 1;

        if (next < markers.length - 1) {

          var originPoint = markers[key].position;
          var destinationPoint = markers[next].position;

          var pointA = new google.maps.LatLng(originPoint.lat, originPoint.lng),
              pointB = new google.maps.LatLng(destinationPoint.lat, destinationPoint.lng);

          //self.initialize(pointA, pointB)

          directionsService.route({
            origin: pointA,
            destination: pointB,
            avoidTolls: true,
            avoidHighways: false,
            travelMode: google.maps.TravelMode.DRIVING
          }, function (response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
              directionsDisplay.setDirections(response);
              //console.log('directions OK')
            } else {
              window.alert('Directions request failed due to ' + status);
            }
          });
        } else {
          if (next == markers.length - 1) {
            //console.log('resetCenter points ended');
            document.getElementsByClassName('showConclusion')[0].classList.add('visible');
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var stylesMap = [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }];
      var markers = this.state.markers;
      var buttonStart = this.props.buttonStart;
      var buttonContinue = this.props.buttonContinue;
      var explanation = this.props.explanation;
      var wrongText = this.props.wrongText;

      var tweets = this.props.tweets;

      var isWrong = this.state.isWrong ? 'show' : 'hide';

      return _react2.default.createElement(
        'div',
        { className: 'mapaInteraction' },
        _react2.default.createElement(
          'div',
          { className: 'tweetsMapa' },
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'div',
              { className: 'explanation' },
              explanation
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'Zuhres', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[0] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'dddd', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[1] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'Torez', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[2] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'dddd', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[3] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'Makiivka', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[4] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'dddd', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[5] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'dddd', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[6] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'Snizhne', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[7] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'Luhansk', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[8] })
            ),
            _react2.default.createElement(
              'div',
              { 'data-marker': 'dddd', className: 'tweetCase2', onClick: this.checkPin.bind(this) },
              _react2.default.createElement('img', { src: this.context.baseUrl + '' + tweets[9] })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'mapa' },
          _react2.default.createElement(_reactGoogleMaps.GoogleMapLoader, {
            containerElement: _react2.default.createElement('div', (0, _extends3.default)({}, this.props, {
              style: {
                height: "100%"
              }
            })),
            googleMapElement: _react2.default.createElement(
              _reactGoogleMaps.GoogleMap,
              { ref: function ref(googleMap) {
                  if (!googleMap) {
                    return;
                  }_this3.gmap = googleMap;
                }, containerProps: { style: { height: "100%" } },
                defaultZoom: 9,
                zoom: 9,
                center: this.state.center,
                defaultCenter: this.state.center,
                defaultOptions: { styles: stylesMap }
              },
              (0, _keys2.default)(markers).map(function (key) {
                return _react2.default.createElement(
                  _reactGoogleMaps.Marker,
                  { key: "marker-" + key, ref: "marker" + key,
                    position: markers[key].position,
                    animation: markers[key].animationPin,
                    icon: { url: markers[key].iconUrl },
                    record_id: markers[key].id },
                  markers[key].showInfo && _react2.default.createElement(
                    _reactGoogleMaps.InfoWindow,
                    { key: 'infoMarker' + key },
                    _react2.default.createElement(
                      'div',
                      { className: 'infoMarker' },
                      markers[key].infoContent
                    )
                  )
                );
              }),
              _react2.default.createElement('div', { className: 'opacityLayer' })
            )

          })
        ),
        _react2.default.createElement('span', { id: 'wrongText', className: isWrong, dangerouslySetInnerHTML: { __html: wrongText } }),
        _react2.default.createElement(
          'div',
          { onClick: this.props.showConclusion.bind(this), className: "showConclusion nextView " + this.props.caseId },
          _react2.default.createElement(
            'span',
            null,
            buttonContinue
          ),
          _react2.default.createElement('i', { className: 'icon-arrowright' })
        )
      );
    }
  }]);
  return Mapa;
}(_react.Component), _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp2);
exports.default = Mapa;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mapa/Mapa.js
// module id = 793
// module chunks = 0